import { CommandRequestType } from "app/services/authentication/connection/commandRequestType";
import { ErrorDetails } from "app/services/authentication/connection/interfaces/apiInterfaces";
import { IRequestCommand } from "app/services/authentication/connection/iRequestCommand";

export class SendVoiceChatMessageCommand extends IRequestCommand<ISendVoiceChatMessageResponse, ErrorDetails, ISendVoiceChatMessageCommandParameter> {
    override _commandType: CommandRequestType = CommandRequestType.POST;
    override _commandUrl = 'chats/add/audio';
}

export interface ISendVoiceChatMessageCommandParameter{
    recipient: string;
    sender: string;
    driverId: number;
    carrierId: number;
    media: string;
    lenght: string;
    driverName: string;
    operatorName: string;
    tokenRecipient: string;
    platform: string;
}

export interface ISendVoiceChatMessageResponse {
}